// `group/field` lets the leading icon turn dusk with the field's focus ring.
export const AUTH_FIELD =
	"group/field h-12 rounded-xl text-base shadow-none sm:text-base **:[input]:h-full **:[input]:placeholder:text-muted-foreground/85";
export const AUTH_FIELD_ICON =
	"size-5 text-muted-foreground transition-colors group-has-[input:focus-visible]/field:text-primary";
export const AUTH_LABEL = "text-base/5 sm:text-base/5";
export const AUTH_SUBMIT =
	"mt-1 h-12 w-full rounded-full font-semibold text-base sm:h-12 sm:text-base";
